import { NavLink } from "react-router-dom";
import { FaInfoCircle } from "react-icons/fa";
import { getImage } from "../../utils/podcastClubUtils";

const stripHtml = (html = "") =>
  html.replace(/<[^>]*>/g, " ").replace(/&nbsp;/g, " ").replace(/\s+/g, " ").trim();

const ClubHeroCard = ({ club, onAbout }) => {
  const mark = getImage(club, "tall");
  const benefit = stripHtml(club.description);
  const short = benefit.length > 160 ? `${benefit.slice(0, 157)}…` : benefit;

  return (
    <>
      <NavLink className="lpc-back" to="/listener-dashboard">← My clubs</NavLink>
      <section className="lpc-hero-card">
        <div className="lpc-hero-card__row">
          {mark && <img className="lpc-hero-card__mark" src={mark} alt="" />}
          <div className="lpc-hero-card__text">
            <h1 className="lpc-hero-card__title">{club.title}</h1>
            {short && <p className="lpc-hero-card__sub">{short}</p>}
          </div>
        </div>
        <button type="button" className="lpc-link-btn" onClick={onAbout}>
          <FaInfoCircle aria-hidden="true" /> About this club
        </button>
      </section>
    </>
  );
};

export default ClubHeroCard;
